import ConsultantsModule from "./ConsultantsModule";

export default function ConsultantsScreen() {
  return <ConsultantsModule />;
}
